export default __webpack_public_path__ + "static/media/default.62312b0f.png";